import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%'
  },
  creditorSection: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius
  },
  addCreditorButton: {
    textTransform: 'none',
    fontWeight: 500,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  addIcon: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  currencyDisplay: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    position: 'relative',
    color: theme.palette.text.secondary,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 30,
      bottom: 30,
      width: 2,
      backgroundColor: theme.palette.grey[500]
    }
  }
}))

export default useStyles
